import React, { FunctionComponent } from 'react';

import clsx from 'clsx';

import { ForBusiness } from '@domains/main-page';

import { Button } from '@components/common/Button/Button';
import { Container } from '@components/common/Container/Container';
import { WysiwygPresenter } from '@components/common/WysiwygPresenter/WysiwygPresenter';
import { BusinessCartIcon, BusinessCartMobileIcon } from '@components/icons';

import styles from './BusinessBlock.module.scss';

type BusinessBlockProps = ForBusiness;

export const BusinessBlock: FunctionComponent<BusinessBlockProps> = (props) => {
    const { title, subtitle, button_text, button_url } = props;

    return (
        <div className={styles.root}>
            <Container>
                <div className={styles.content}>
                    <div className={styles.info}>
                        {title !== null && (
                            <WysiwygPresenter content={title} className={styles.title} />
                        )}
                        {subtitle !== null && (
                            <WysiwygPresenter content={subtitle} className={styles.description} />
                        )}
                    </div>
                    {button_url !== null && button_text !== null && (
                        <Button variant="white" className={styles.button} link={button_url}>
                            <WysiwygPresenter content={button_text} />
                        </Button>
                    )}
                    <BusinessCartIcon className={styles.businessCart} />
                    <BusinessCartMobileIcon
                        className={clsx(styles.businessCart, styles.isMobile)}
                    />
                </div>
            </Container>
        </div>
    );
};
